/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  products: {
    '& > .content': {
      gap: pxToEm(0)
    },
    '& .productitem': {
      opacity: 0.5,
      pointerEvents: 'none',
      fontSize: themeV2.typography.size.xsmall.fontSize,
      fontWeight: themeV2.typography.weight.medium,
      lineHeight: '16px',
      height: '40px',
      width: '100%', //pxToEm(650),
      display: 'inline-flex',
      alignItems: 'center',
      padding: '12px',
      margin: '6px',
      backgroundColor: themeV2.color.base.white,
      border: `${pxToEm(1)} solid ${themeV2.color.base.gray.light}`,
      borderRadius: '12px',
      '& .icon': {
        opacity: '0.5'
      },
    },
   '& .single-item-list': {
    width: '100%',
    '& .list-item': {
      '& .option-text': {
        width: '100%'
      }
    }
   },
    '& .sortablelist': {
      '& > div > div': {
        top: 'auto !important',
        left: 'auto !important'
      }
    }
  },
  '& .disabled-true': {
    pointerEvents: 'none',
    opacity: 0.4
  },
});
